export default {
    values: {
        'Back To': 'Back To',
        'Showing': 'Showing',
        'Results': 'Results',
        'Remove filters': 'Remove filters',
        'Download list': 'Download list',
        selected_label: 'selected'
    }
}
